<template>
    <hox-alert type="info" size="small">
        <template #title>
            <p>This could take a while</p>
        </template>

        <template #content>
            <p>
                You will be notified when they are ready to download and you will be able to find download links in your
                notifications.
            </p>

            <p v-if="isGenericLiteDownload">
                <br />
                Please make sure you read the
                <span class="download-modal__changes-overview-link" @click="emit('tabChange', 'changesOverview')">
                    changes overview
                </span>
                tab to understand the limitations of this format before downloading.
            </p>
        </template>
    </hox-alert>
</template>

<script lang="ts" setup>
import { DOWNLOAD_FORMAT, type DownloadFormatType } from "hoxton-shared/enums/exports";
import { computed } from "vue";

const { platform } = defineProps<{
    platform: DownloadFormatType;
}>();

const emit = defineEmits<(e: "tabChange", tab: "downloadOptions" | "changesOverview") => void>();

const isGenericLiteDownload = computed(() => {
    return platform === DOWNLOAD_FORMAT.GENERIC_LITE;
});
</script>

<style lang="scss" scoped>
@use "@style/variables" as *;
.download-modal__changes-overview-link {
    color: $primary-color;
    text-decoration: underline;
    cursor: pointer;
}
</style>
